import {
  LAYOUT_DATA,
  REFETCH_LAYOUT,
  DEFAULT_COLOR,
  DEFAULT_NAV_BAR_COLOR,
  TAB_MOTION,
  MODAL_OPEN,
  PAYMENT_AMOUNT,
  DEBTOR_RIGHTS_MODAL,
  ESIGN_MODAL,
  ESIGN_MODAL_STORE,
  DATE_FORMAT_LAYOUT,
  IS_DISCOUNT_PERCENTAGE,
  IS_TAB_INVOICE,
  IS_PAY_MULTI_OPTION,
  IS_PAY_MULTI_OPTION_RESET,
  IS_MULTI_MODAL_OPEN,
  IS_OPEN_BASED_TYPE,
  IS_PAYMENT_PLAN_DATA,
  IS_NSF_COUNT,
} from "./action";
import { getSafeTimeZone } from "../../utils/getSafeTimeZone";

const initialState = {
  tabMotion: "0",
  userData: "",
  organization: {},
  is_document_authorize_configured: false,
  document_authorize_configurations: [],
  invoice: {},
  payment: {},
  time: [],
  customer: {},
  requestBack: {},
  callBack: {},
  callBackData: {},
  requestTimeData: {},
  isLoading: false,
  refetchData: 0,
  dateFormat: "",
  amountFormat: "",
  referenceData: [],
  selectedInvoice: [],
  default_color: "#1A73E8",
  default_nav_color: "#08083A",
  org_logo: null,
  modalState: true,
  retriveDocument: [],
  paymentAmount: "",
  is_mini_miranda_configured: false,
  debtor_rights_modal: false,
  isEsign: false,
  isEsignStore: false,
  isMultiModal: true,
  isOpenBasedType: "",
  isPaymentPlanData: {},
  isDiscountPercentage: {
    isDiscount: true,
    isEdit: false,
  },
  isNsfCount: 0,
  isPaymentOption: {
    option: false,
    payAmount: null,
    isEdit: false,
    skipMinPayment: false,
  },
};

const layoutReduce = (state = initialState, { type, payload }) => {
  switch (type) {
    case DEFAULT_COLOR: {
      return {
        ...state,
        default_color: payload,
      };
    }

    case DATE_FORMAT_LAYOUT: {
      return {
        ...state,
        dateFormat: payload,
      };
    }
    case TAB_MOTION: {
      return {
        ...state,
        tabMotion: payload,
      };
    }
    case DEFAULT_NAV_BAR_COLOR: {
      return {
        ...state,
        default_nav_color: payload,
      };
    }

    case LAYOUT_DATA:
      //   let org = payload.data?.doc.payment;

      if (
        payload.organization &&
        payload.organization.customer_portal_ui &&
        payload.organization.customer_portal_ui.primary_color
      ) {
        document.documentElement.style.setProperty(
          "--primary",
          payload.organization.customer_portal_ui.primary_color
        );
      }

      return {
        ...state,
        organization: {
          ...payload.organization,
          time_zone: getSafeTimeZone(payload.organization?.time_zone),
        },
        is_document_authorize_configured:
          payload.is_document_authorize_configured,
        document_authorize_configurations:
          payload.document_authorize_configurations,
        invoice: payload.invoice,
        payment: payload.payment,
        paymentReceiptConfigured: payload,
        time: payload.rd.time,
        customer: payload.customer,
        // requestBack: payload.request_back,
        // callBack: payload.callback,
        // callBackData: payload.callback_data,
        is_mini_miranda_configured: payload.is_mini_miranda_configured,
        requestTimeData: payload.request_time_data,
        accessData: payload,
        dateFormat: payload.organization.date_format,
        amountFormat: payload.organization.amount_format,
        isLoading: true,
        referenceData: payload.rd,
        default_color:
          payload.organization &&
          payload.organization.customer_portal_ui &&
          payload.organization.customer_portal_ui.primary_color
            ? payload.organization.customer_portal_ui.primary_color
            : "#1A73E8",
        default_nav_color:
          payload.organization &&
          payload.organization.customer_portal_ui &&
          payload.organization.customer_portal_ui.header_color
            ? payload.organization.customer_portal_ui.header_color
            : "#08083A",
        org_logo:
          payload.organization &&
          payload.organization.customer_portal_ui &&
          payload.organization.customer_portal_ui.logo
            ? payload.organization.customer_portal_ui.logo
            : null,
      };

    case REFETCH_LAYOUT:
      return {
        ...state,
        refetchData: state.refetchData + 1,
      };

    case MODAL_OPEN:
      return {
        ...state,
        modalState: payload,
      };

    case PAYMENT_AMOUNT:
      return {
        ...state,
        paymentAmount: payload,
      };

    case DEBTOR_RIGHTS_MODAL:
      return {
        ...state,
        debtor_rights_modal: payload,
      };

    case ESIGN_MODAL:
      return {
        ...state,
        isEsign: payload,
      };

    case ESIGN_MODAL_STORE:
      return {
        ...state,
        isEsignStore: payload,
      };

    case IS_DISCOUNT_PERCENTAGE:
      return {
        ...state,
        isDiscountPercentage: {
          isDiscount: payload.isDiscount,
          isEdit: payload.isEdit,
        },
      };
    case IS_TAB_INVOICE:
      return {
        ...state,
        isInvoiceTabActive: payload,
      };
    case IS_PAY_MULTI_OPTION:
      return {
        ...state,
        isPaymentOption: payload,
      };
    case IS_PAY_MULTI_OPTION_RESET:
      return {
        ...state,
        isPaymentOption: initialState.isPaymentOption,
      };
    case IS_MULTI_MODAL_OPEN:
      return {
        ...state,
        isMultiModal: payload,
      };
    case IS_OPEN_BASED_TYPE:
      return {
        ...state,
        isOpenBasedType: payload,
      };
    case IS_PAYMENT_PLAN_DATA:
      return {
        ...state,
        isPaymentPlanData: payload,
      };
    case IS_NSF_COUNT:
      return {
        ...state,
        isNsfCount: payload,
      };
    default:
      return state;
  }
};

export default layoutReduce;
